import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';

export function safeLegendColor(params /*, hash*/) {
    let color = params[0];
    return htmlSafe(`<td class="styled-div" style="background-color: ${color};"></td>`);
}

export default helper(safeLegendColor);
